module.exports = __webpack_public_path__ + "static/media/about_us.17816ff5.svg";